import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Grid } from 'semantic-ui-react';
import { PasswordForm } from 'components';

import * as auth from 'actions/auth';
import toastr from 'helpers/toastr';
import base64 from 'helpers/base64';
import storage from 'helpers/storage';

const defaultErrorMessage = '서비스에 오류가 발생하였습니다. 식권대장에 문의해주세요.';

const propTypes = {
  location: PropTypes.objectOf(PropTypes.any).isRequired,
  authAction: PropTypes.objectOf(PropTypes.func).isRequired
};

const defaultProps = {};

class LoginPasswordChange extends Component {
  constructor(props) {
    super(props);
    this.state = {
      password: '',
      rePassword: ''
    };
  }

  async componentWillMount() {
    const {
      location: { account }
    } = this.props;
    const { router } = this.context;
    if (!account || !account.guid) {
      router.history.push('/');
    }
  }

  handleChange = (value, name) => {
    this.setState({
      [name]: value
    });
  };

  skipPasswordChange = async () => {
    const { authAction } = this.props;
    const { router } = this.context;
    try {
      await authAction.skipPasswordAPI();
      storage.remove('password');
      router.history.push('/service/landing');
    } catch (error) {
      const result = error.response;
      console.log(result);
      if (result && result.data) {
        const { status } = result.data;
        if (status) {
          toastr('top-right', 'warning', result.data.message);
        } else {
          toastr('top-right', 'warning', defaultErrorMessage);
          // this.context.router.history.push('/');
        }
      }
      console.log('###### e : ', error);
    }
  };

  passwordChange = async () => {
    const { password, rePassword } = this.state;
    const {
      authAction,
      location: { account },
      rootProps
    } = this.props;
    const { router } = this.context;

    if (!password) {
      toastr('top-right', 'warning', '비밀번호를 입력해주세요.');
      return;
    }

    if (password.length < 8 || password.length > 20) {
      toastr('top-right', 'warning', '비밀번호는 최소 8자 최대 20자까지 입력 가능합니다.');
      return;
    }

    if (password !== rePassword) {
      toastr('top-right', 'warning', '재입력한 비밀번호가 일치하지 않습니다.');
      return;
    }

    // 비밀번호 변경
    try {
      const params = {
        id: account.guid,
        type: 'USER',
        target: base64.encode(password)
      };
      // 인증 서버 호출
      await authAction.changePasswordAPI(params);
      storage.remove('password');

      toastr('top-right', 'success', '비밀번호가 변경되었습니다.');

      const { logout } = rootProps;
      await logout();
    } catch (e) {
      const result = e.response;
      console.log(result);

      if (result && result.data) {
        const { status } = result.data;
        if (status) {
          toastr('top-right', 'warning', result.data.message);
        } else {
          toastr('top-right', 'warning', defaultErrorMessage);
        }
      }

      console.log('###### e : ', e);
    }
  };

  render() {
    const {
      location: { account }
    } = this.props;
    const type = account ? account.password : '';
    return (
      <Grid className="login" textAlign="center">
        <PasswordForm
          passwordChangeAction={this.passwordChange}
          skipAction={this.skipPasswordChange}
          handleChange={this.handleChange}
          type={type}
        />
      </Grid>
    );
  }
}

LoginPasswordChange.contextTypes = {
  router: PropTypes.objectOf(PropTypes.any).isRequired
};

LoginPasswordChange.propTypes = propTypes;
LoginPasswordChange.defaultProps = defaultProps;

export default connect(
  (state) => ({
    changePWD: state.auth.changePWD
  }),
  (dispatch) => ({
    authAction: bindActionCreators(
      {
        changePasswordAPI: auth.changePasswordAPI,
        skipPasswordAPI: auth.changePasswordIgnoreAPI
      },
      dispatch
    )
  })
)(LoginPasswordChange);
